import React from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import DocumentExtractor from './components/DocumentExtractor';
import LoginPage from './components/LoginPage';
import './index.css';

function AppContent() {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <div className="App">
      <DocumentExtractor />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;